// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { GetAuthData, GetAuthResponse, GetCandlesData, GetCandlesResponse, GetDeltaSignalData, GetDeltaSignalResponse, GetPricesData, GetPricesResponse, GetSgManifestResponse, GetSgTnsContractsData, GetSgTnsContractsResponse, GetSgTnsFeedData, GetSgTnsFeedResponse, GetSgTnsFlowSumData, GetSgTnsFlowSumResponse, GetSgTnsHighlightsData, GetSgTnsHighlightsResponse, GetStatusData, GetStatusResponse, GetStreamData, GetV2OpenInterestIntradayDeltaData, GetV2OpenInterestIntradayDeltaResponse, GetV2OpenInterestIntradayGammaData, GetV2OpenInterestIntradayGammaResponse, GetV2OpenInterestIntradayStatsData, GetV2OpenInterestIntradayStatsResponse, GetV2OpenInterestIntradayStrikeBarsData, GetV2OpenInterestIntradayStrikeBarsResponse, GetV2OpenInterestIntradayTimestampsData, GetV2OpenInterestIntradayTimestampsResponse, GetValidateBearerResponse, GetVixQuoteData, GetVixQuoteResponse } from './types.gen';

export class DefaultService {
    /**
     * The handler for the auth request which generates a token to validate based on basic client
     * ID/secret authentication
     * @param data The data for the request.
     * @param data.authorization Basic Authentication
     * @returns string Success
     * @throws ApiError
     */
    public static getAuth(data: GetAuthData): CancelablePromise<GetAuthResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/auth',
            headers: {
                authorization: data.authorization
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @param data.stream
     * @param data.field
     * @param data.option
     * @param data.filter
     * @param data.limit
     * @param data.start start timestamp in milliseconds
     * @param data.end end timestamp in milliseconds
     * @returns string Success
     * @throws ApiError
     */
    public static getCandles(data: GetCandlesData): CancelablePromise<GetCandlesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/candles',
            query: {
                sym: data.sym,
                stream: data.stream,
                field: data.field,
                option: data.option,
                filter: data.filter,
                limit: data.limit,
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.optionAccumulationType
     * @param data.optionOrigin
     * @param data.isFiltered
     * @param data.candleDurationMs duration of candles. Must be a multiple of 5000
     * @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.limit max number of items to return. Default 100, max 20_000
     * @returns DeltaSignalRsp Success
     * @throws ApiError
     */
    public static getDeltaSignal(data: GetDeltaSignalData): CancelablePromise<GetDeltaSignalResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/delta_signal',
            query: {
                symbol: data.symbol,
                option_accumulation_type: data.optionAccumulationType,
                option_origin: data.optionOrigin,
                is_filtered: data.isFiltered,
                time_gte: data.timeGte,
                time_lt: data.timeLt,
                candle_duration_ms: data.candleDurationMs,
                limit: data.limit
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.candleDurationMs duration of candles. Must be a multiple of 5000
     * @param data.timeGte ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.timeLt ISO 8601 formatted date-time string like "2025-01-01T05:01:17"
     * @param data.limit max number of items to return. Default 100, max 20_000
     * @returns CandlesRsp Success
     * @throws ApiError
     */
    public static getPrices(data: GetPricesData): CancelablePromise<GetPricesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/prices',
            query: {
                symbol: data.symbol,
                time_gte: data.timeGte,
                time_lt: data.timeLt,
                candle_duration_ms: data.candleDurationMs,
                limit: data.limit
            }
        });
    }
    
    /**
     * Fetches the list of available instruments for the day
     * @returns Manifest
     * @throws ApiError
     */
    public static getSgManifest(): CancelablePromise<GetSgManifestResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/manifest'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns ContractRow Success
     * @throws ApiError
     */
    public static getSgTnsContracts(data: GetSgTnsContractsData = {}): CancelablePromise<GetSgTnsContractsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_contracts',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales feed
     * @param data The data for the request.
     * @param data.filters
     * @param data.sorting
     * @param data.offset
     * @param data.limit
     * @returns string Success
     * @throws ApiError
     */
    public static getSgTnsFeed(data: GetSgTnsFeedData = {}): CancelablePromise<GetSgTnsFeedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_feed',
            query: {
                filters: data.filters,
                sorting: data.sorting,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * The handler for the Time & Sales flow summary. Aggregate: volume, premium, delta, gamma, vega
     * @param data The data for the request.
     * @param data.filters
     * @returns HiroAggSummary Success
     * @throws ApiError
     */
    public static getSgTnsFlowSum(data: GetSgTnsFlowSumData = {}): CancelablePromise<GetSgTnsFlowSumResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_flow_sum',
            query: {
                filters: data.filters
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.start
     * @param data.end
     * @returns Highlights Success
     * @throws ApiError
     */
    public static getSgTnsHighlights(data: GetSgTnsHighlightsData = {}): CancelablePromise<GetSgTnsHighlightsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/sg/tns_highlights',
            query: {
                start: data.start,
                end: data.end
            }
        });
    }
    
    /**
     * The handler for the auth request which generates a token to validate based on basic client
     * ID/secret authentication
     * @param data The data for the request.
     * @param data.authorization Bearer <jwt-token>
     * @returns ServerStatus Success
     * @throws ApiError
     */
    public static getStatus(data: GetStatusData): CancelablePromise<GetStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/status',
            headers: {
                authorization: data.authorization
            }
        });
    }
    
    /**
     * The handler for the HTTP request (this gets called when the HTTP GET lands at the start
     * of websocket negotiation). After this completes, the actual switching from HTTP to
     * websocket protocol will occur.
     * This is the last point where we can extract TCP/IP metadata such as IP address of the client
     * as well as things from HTTP headers such as user-agent of the browser etc.
     * @param data The data for the request.
     * @param data.token
     * @throws ApiError
     */
    public static getStream(data: GetStreamData): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stream',
            query: {
                token: data.token
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.mktActor
     * @param data.date
     * @param data.ts
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayDelta(data: GetV2OpenInterestIntradayDeltaData): CancelablePromise<GetV2OpenInterestIntradayDeltaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_delta',
            query: {
                symbol: data.symbol,
                date: data.date,
                ts: data.ts,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.symbol
     * @param data.mktActor
     * @param data.date
     * @param data.ts
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayGamma(data: GetV2OpenInterestIntradayGammaData): CancelablePromise<GetV2OpenInterestIntradayGammaResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_gamma',
            query: {
                symbol: data.symbol,
                date: data.date,
                ts: data.ts,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.sym
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayStats(data: GetV2OpenInterestIntradayStatsData): CancelablePromise<GetV2OpenInterestIntradayStatsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_stats',
            query: {
                sym: data.sym,
                date: data.date
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.barType
     * @param data.symbol
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayStrikeBars(data: GetV2OpenInterestIntradayStrikeBarsData): CancelablePromise<GetV2OpenInterestIntradayStrikeBarsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_strike_bars',
            query: {
                symbol: data.symbol,
                bar_type: data.barType,
                date: data.date
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.greek
     * @param data.mktActor
     * @param data.symbol
     * @param data.date
     * @returns unknown Success
     * @throws ApiError
     */
    public static getV2OpenInterestIntradayTimestamps(data: GetV2OpenInterestIntradayTimestampsData): CancelablePromise<GetV2OpenInterestIntradayTimestampsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/open_interest/intraday_timestamps',
            query: {
                symbol: data.symbol,
                greek: data.greek,
                date: data.date,
                mkt_actor: data.mktActor
            }
        });
    }
    
    /**
     * A simple handler for validating and inspecting a JWT token
     * @returns Claims Success
     * @throws ApiError
     */
    public static getValidateBearer(): CancelablePromise<GetValidateBearerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validate_bearer'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.dates
     * @returns Page_VixQuote Success
     * @throws ApiError
     */
    public static getVixQuote(data: GetVixQuoteData = {}): CancelablePromise<GetVixQuoteResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vix_quote',
            query: {
                dates: data.dates
            }
        });
    }
    
}